import type { MessageSchema } from '@/i18n/types';

const kk: MessageSchema['help'] = {
    categories: {
        content:     'Контентке қатысты мәселелер',
        improvement: 'Жақсарту бойынша ұсыныстар',
        other:       'Басқа сұрақ',
        refill:      'Лидтерді толықтыруға өтінім',
        site:        'Сайт бойынша көмек қажет',
        technical:   'Техникалық мәселелер',
    },
    chooseCategory:     'Санатты таңдаңыз:',
    commentPlaceholder: 'Пікіріңізді жазыңыз',
    dealerComment:      'Автосалон {name}',
    error:              'Бірдеңе дұрыс болмады, қайта байқап көріңіз',
    success:            'Өтінім жіберілді',
};

export default kk;
